import React from "react";
// import servicesvg from "../../../../../../Assets/assetsnew/service.svg";

import Styled from "./ServicesStyles";
import TextStyles from "../../../../../../Constants/TextStyles";

const Services = ({ selectedData }) => {
  const service_list = selectedData && selectedData.service_list;
  return (
    <Styled.ReviewBox className="mt-4">
      <div className="d-flex gap-2 gap-md-3 align-items-center mb-3 w-100">
        <img src='/images/services summary.svg' alt="service icon" width={35} />
        <TextStyles.FontSize18px className="three-dots fw-medium">
          Services Summary
        </TextStyles.FontSize18px>
      </div>

      {service_list &&
        service_list.map((item, index) => {
          return (
            <Styled.EditServiceContainer key={index}>
              <div
                className="my-3 w-100"
                style={{
                  height: "0.5px",
                  backgroundColor: "#aaa",
                }}
              />

              <div className="fw-medium d-flex fw-medium gap-3 justify-content-between align-items-end">
                <TextStyles.FontSize16px className="three-dots">
                  {index + 1}. {item.service_name}
                </TextStyles.FontSize16px>

                <TextStyles.FontSize16px
                  className="text-end"
                  style={{ minWidth: "11.5rem" }}
                >
                  {selectedData &&
                    selectedData.currency &&
                    selectedData.currency.symbol}
                  {item.service_rate
                    ? parseFloat(item.service_rate).toFixed(2)
                    : "00.00"}
                  {item.service_rate_type !== "Flat fee"
                    ? ` ${item.service_rate_type.toLocaleLowerCase()}`
                    : ` ${item.service_rate_type.toLocaleLowerCase()}`}
                </TextStyles.FontSize16px>
              </div>

              {item.desc && (
                <TextStyles.FontSize14px className="mt-1 ms-3 lh-lg">
                  {item.desc}
                </TextStyles.FontSize14px>
              )}
            </Styled.EditServiceContainer>
          );
        })}
    </Styled.ReviewBox>
  );
};

export default Services;
